var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMultiply = function SvgMultiply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.85 7 8.34l-3.5 3.51-1.35-1.35L5.66 7 2.15 3.5 3.5 2.15 7 5.66l3.5-3.51 1.35 1.35L8.34 7l3.51 3.5Z"
  })));
};

export default SvgMultiply;